import BetShow from './bet.show';
import BetList from './bet.list';

export default {
  show: BetShow,
  list: BetList,
};
